import styled from 'styled-components'

import Theme from '@theme'

type Props = {
  padding?: number | string
}

const Line = styled.div`
  margin: 0 0 8px 2px;
  background-color: ${Theme.defaultColor};
  height: 0.125rem;
  width: ${({ width }) => width};
`

export const SubmissionTextThumbnail: React.FC<Props> = ({ padding = '30% 30% 30% 30%' }) => {
  return (
    <div
      style={{
        paddingTop: '100%',
        position: 'relative',
        margin: '0 4px 24px 0',
        backgroundColor: Theme.grey200Color,
      }}
      data-testid="submission-text-thumbnail"
    >
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          padding,
          boxSizing: 'border-box',
        }}
      >
        <Line width="100%" />
        <Line width="80%" />
        <Line width="100%" />
        <Line width="60%" />
      </div>
    </div>
  )
}
